export enum FormBaseComponentState {
  EnterData = 0,
  ConfirmForm,
  SendingForm,
  FormWasSend,
  FormSendFailed
}
